




















import { mapState } from "vuex";
import BreadcrumbLink from "@/common/components/atoms/BreadcrumbLink.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";

@Component({
  components: { BreadcrumbLink }
})
export default class TheBreadcrumb extends Vue {
  breadcrumb = commons.breadcrumb;
  get lastElementKey() {
    return commons.breadcrumb.length - 1;
  }

  get internalBreadcrumb() {
    return commons.breadcrumb.filter((v: any) => v);
  }
}
